import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden" style={{ background: 'linear-gradient(135deg, hsl(220 25% 8%) 0%, hsl(220 20% 14%) 100%)' }}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute inset-0 text-white" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, currentColor 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="container-padding max-w-7xl mx-auto relative z-10 pt-20">
        <div className="max-w-4xl">
          <p className="text-primary font-medium text-sm md:text-base mb-6 opacity-0-initial animate-fade-up">
            Digital & IT Agency in Hong Kong
          </p>
          
          <h1 className="heading-xl text-white mb-8">
            We craft digital
            <span className="block">experiences that</span>
            <span className="text-primary">stand out</span>
          </h1>
          
          <p className="text-lg md:text-xl text-white/70 max-w-2xl mb-10 opacity-0-initial animate-fade-up stagger-2">
            Hong Kong web design, app development and branding for businesses that want to stand out.
            For small businesses, see a free demo of your new site before you pay anything.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 opacity-0-initial animate-fade-up stagger-3">
            <a
              href="/websites"
              className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-8 py-4 rounded-lg font-medium transition-all duration-300 hover:bg-primary/90 hover:gap-4"
            >
              Zero Deposit Website
              <ArrowRight size={18} aria-hidden="true" focusable="false" />
            </a>
            <a
              href="/get-started"
              className="inline-flex items-center justify-center gap-2 border border-white/20 text-white px-8 py-4 rounded-lg font-medium transition-all duration-300 hover:border-primary hover:text-primary"
            >
              Get Your Demo
              <ArrowRight size={18} aria-hidden="true" focusable="false" />
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button 
        onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 opacity-0-initial animate-fade-in stagger-5 cursor-pointer hover:scale-110 transition-transform duration-300"
        aria-label="Scroll to next section"
      >
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center hover:border-white/50 transition-colors">
          <div className="w-1.5 h-3 bg-white/50 rounded-full mt-2 animate-bounce" />
        </div>
      </button>
    </section>
  );
};

export default Hero;
